import { type IngestionRuleRecord } from "./IngestionRuleRecord";

/** "a", "a or b", "a, b, or c". */
const disjunction = new Intl.ListFormat("en", { type: "disjunction" });

/**
 * A rule in one sentence, e.g. "Files matching **\/*.mcap are ingested with
 * ros_ingestion." Excludes are said too; a rule without auto-ingest only makes
 * sessions wait for its files.
 */
export function describeIngestionRule(
  rule: Pick<
    IngestionRuleRecord,
    "include_patterns" | "exclude_patterns" | "invocation" | "auto_ingest"
  >,
): string {
  const except =
    rule.exclude_patterns.length > 0
      ? `, except ${disjunction.format(rule.exclude_patterns)}`
      : "";
  const patterns = disjunction.format(rule.include_patterns);
  return rule.auto_ingest && rule.invocation !== null
    ? `Files matching ${patterns} are ingested with ${rule.invocation.action.name}${except}.`
    : `Sessions wait for files matching ${patterns}${except}. Auto-ingest is off, so nothing ingests them automatically.`;
}
